import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {notEligibleSelect} from '../../redux/selector/notEligibleSelector'
import {
    Header, 
    Paragraph, 
    NavigationLinkButton
} from '../../components/RegularComponents'
import Navigation from '../Navigation';
import { 
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    APPLICATION_TYPE_COLLECTOR,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT
 } from '../../app/constants';

function NotEligible (props) { 
    const {notEligible} = props
    const{applicationType} = props.match.params

    let applicationTypeString = ""

    if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY) { 
        applicationTypeString = "collection agency licence"
    } else if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
        applicationTypeString = "debt management agency licence"
    } else if(applicationType === APPLICATION_TYPE_COLLECTOR) {
        applicationTypeString ="collector licence"
    } else if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
        applicationTypeString ="debt management agent licence"
    }

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <div className="col-lg-8">
                    <div className="row">
                        <Header header={`Your company is not eligible for a ${applicationTypeString}`}/>
                        <Paragraph text={notEligible.text} />
                    </div>
                    <div className="row">
                        <NavigationLinkButton
                            onClick={() => {
                                props.dispatch(push(notEligible.navigation.next))
                            }}
                            text={`Return to ${applicationTypeString} page`}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(notEligibleSelect)(NotEligible)